import Mandataires from "./Mandataires";

export default Mandataires;
